import Vue from 'vue';
let ispc=function ispc(){
    return !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
}
  // 注册插件全局通用
export default {
    install() {
      Vue.prototype.$ispc = ispc;
    },
    ispc
  }